import React, { useEffect } from 'react';

import amplitude from 'amplitude-js';
import { DangerouslyHtml } from 'apps/auth/components/common/DangerouslyHtml/DangerouslyHtml';
import ReportProblemModal from 'apps/auth/components/common/Modal/ReportProblemModal';
import PopupButton from 'apps/auth/components/common/Popup/PopupButton';
import SimplePopup from 'apps/auth/components/common/Popup/SimplePopup';
import { CHECK_PHONE_NUMBER_BOTTOM_SHEET_SHOWN } from 'apps/auth/constants/amplitude/AmplitudeEvents';
import { resolveArguments } from 'apps/auth/helpers/utils';
import { useLibPhonenumberFormatter } from 'apps/auth/hooks/useLibPhonenumberFormatter';

type PopupHandle = { close: () => void };
type ModalHandle = { open: (content: React.ReactNode) => void; close: () => void };

interface PhoneSuggestionPopupProps {
    popupRef: React.RefObject<PopupHandle>;
    text: string;
    enteredNumber: string;
    suggestedNumber: string;
    countryCode: string;
    buttonText: string;
    onConfirm: () => void;
    modalRef?: React.RefObject<ModalHandle>;
    reportProblemButton?: string;
    reportButtonClick?: (field: unknown, errorMessage?: string) => void;
    field?: unknown;
    errorMessage?: string;
}

const PhoneSuggestionPopup = ({
    popupRef,
    text,
    enteredNumber,
    suggestedNumber,
    countryCode,
    buttonText,
    onConfirm,
    modalRef,
    reportProblemButton,
    reportButtonClick,
    field,
    errorMessage,
}: PhoneSuggestionPopupProps) => {
    const { ready, formatIntlPhoneNumber } = useLibPhonenumberFormatter();

    useEffect(() => {
        amplitude.getInstance().logEvent(CHECK_PHONE_NUMBER_BOTTOM_SHEET_SHOWN);
    }, []);

    const formatPhoneNumber = (phoneNumber: string) => {
        if (!phoneNumber) {
            return '';
        }
        const formattedPhoneNumber = ready ? formatIntlPhoneNumber(phoneNumber, countryCode) : phoneNumber;
        return formattedPhoneNumber.startsWith('+') ? formattedPhoneNumber : `+${formattedPhoneNumber}`;
    };
    const prependPlus = (phoneNumber: string) => (phoneNumber?.startsWith('+') ? phoneNumber : `+${phoneNumber ?? ''}`);
    const resolved = resolveArguments(text, [`<span class="color-red">${prependPlus(enteredNumber)}</span>`, formatPhoneNumber(suggestedNumber)]).replaceAll(
        '\n',
        '<br />',
    );

    return (
        <SimplePopup popupRef={popupRef} text={<DangerouslyHtml dangerouslyHtml={resolved} />}>
            <PopupButton
                iconName="check"
                text={buttonText}
                onClick={() => {
                    popupRef.current?.close();
                    onConfirm();
                }}
            />
            {reportButtonClick && (
                <PopupButton
                    iconName="lifebuoy"
                    text={reportProblemButton}
                    onClick={() => {
                        modalRef?.current?.open(<ReportProblemModal modalRef={modalRef} />);
                        reportButtonClick(field, errorMessage);
                        popupRef.current?.close();
                    }}
                />
            )}
        </SimplePopup>
    );
};

export default PhoneSuggestionPopup;
